import request from '@/utils/request'
import { getToken } from '../../utils/auth'

// 机构查询没有入住的养老服务对象
export function queryelderlynobed (params, data) {
  params.token = getToken()
  return request({ url: '/queryelderlynobed', method: 'post', params, data })
}

// 机构查询已经入住的养老服务对象
export function queryelderlyhasbed (params, data) {
  params.token = getToken()
  return request({ url: '/queryelderlyhasbed', method: 'post', params, data })
}



// WEBPACK FOOTER //
// ./src/api/yanglaoyuan/elderly.js